/* Safari evicts a website's storage after 7 days without a visit (installed
   Home Screen apps are exempt), and every browser may evict under storage
   pressure. Asking for persistent storage opts out where the browser allows. */
export async function requestPersistence(): Promise<boolean> {
  try {
    if (!navigator.storage?.persist) return false;
    if (await navigator.storage.persisted()) return true;
    return await navigator.storage.persist();
  } catch { return false; }
}

export async function isPersisted(): Promise<boolean | null> {
  try { return navigator.storage?.persisted ? await navigator.storage.persisted() : null; } catch { return null; }
}

/** Every local collection, for backup/export. */
export const BACKUP_KEYS = ['sessions', 'goals', 'prayers', 'adhkar', 'bookmarks', 'lectureMarks', 'fasts', 'periods', 'khatmahs', 'ayahLog', 'dhikr', 'hifz', 'hifzPages', 'hifzLog', 'hifzLessons', 'lastRead'] as const;
